const routes = [
    {
        path: '',
        redirect: 'NotFound'
    },
    {
        path: '/:mchId(\\d+)',
        redirect: ':mchId(\\d+)/Portal'
    },

    {
        path: '/:mchId/Portal',
        name: 'Portal',
        meta: {
            title: '首页',
            isFlag: true       // 是否显示底部导航栏
        },
        component: () => import('@/views/Portal/Index.vue')
    },
    {
        path: '/:mchId/Catalog',
        name: 'Catalog',
        meta: {
            title: '分类',
            isFlag: true
        },
        component: () => import('@/views/Catalog/Index.vue'),
    },
    {
        path: "/:mchId/Search",
        name: "Search",
        component: () => import('@/views/Catalog/Search/Index.vue'),
        meta: {
            title: '分类',
            isFlag: false,
        },
    },

    {
        path: "/:mchId/SearchResult",
        name: "SearchResult",
        component: () => import('@/views/Catalog/Search/Result.vue'),
        meta: {
            title: '分类',
            isFlag: false,
        },
    },

    {
        path: '/:mchId/MallCart',
        name: 'MallCart',
        meta: {
            title: '购物车',
            isFlag: true,
        },
        component: () => import('@/views/MallCart/Index.vue')
    },

    {
        path: '/:mchId(\\d+)/My',
        name: 'My',
        meta: {
            title: '个人中心',
            isFlag: true
        },
        redirect: '/:mchId(\\d+)/My/Personal',
        component: () => import('@/views/My/Index.vue'),
        children: [
            {
                path: '/:mchId(\\d+)/My/Personal',
                name: 'My-Personal',
                meta: {
                    title: '个人中心',
                    isFlag: true
                },
                component: () => import('@/views/My/Personal.vue'),
            },
            {
                path: '/:mchId(\\d+)/My/Coupon',
                name: 'My-Coupon',
                component: () => import('@/views/My/Coupons/Index.vue'),
                redirect: '/:mchId(\\d+)/My/Coupon/List',
                children: [
                    {
                        path: '/:mchId(\\d+)/My/Coupon/List',
                        name: 'My-CouponList',
                        meta: {
                            title: '我的卡包',
                            isFlag: false
                        },
                        component: () => import('@/views/My/Coupons/List.vue'),
                    },
                    {
                        path: '/:mchId(\\d+)/My/Coupon/Detail',
                        name: 'My-CouponDetail',
                        meta: {
                            title: '卡券详情',
                            isFlag: false
                        },
                        component: () => import('@/views/My/Coupons/Detail.vue'),
                    }
                ],
            }
        ]
    },

    {
        path: '/:mchId(\\d+)/MyCard', //作废，用'/:mchId(\\d+)/My/Coupon',此处兼容旧公众号
        name: 'MyCard',
        meta: {
            title: '我的卡包',
            isFlag: false,
        },
        component: () => import('@/views/My/Card/Index.vue'),
        redirect: '/:mchId(\\d+)/My/Coupon/List',
    },
    {
        path: '/:mchId/Portal/ChooseProduct',
        name: 'ChooseProduct',
        meta: {
            title: '选择产品',
            isFlag: false,
        },
        component: () => import('@/views/Portal/ChooseProduct.vue')
    },

    {
        path: '/:mchId/Goods',
        name: 'GoodsDetails',
        meta: {
            title: '商品详情',
            isFlag: false,
        },
        component: () => import('@/views/Goods/Detail.vue')
    },
    {
        path: '/:mchId/GoodsComments',
        name: 'GoodsComments',
        meta: {
            title: '商品评价',
            isFlag: false,
        },
        component: () => import('@/views/My/Comment/GoodsComments.vue')
    },

    {
        path: '/:mchId/Activity/Collage',
        name: 'Collage',
        meta: {
            title: '差价拼团',
            isFlag: false,
        },
        component: () => import('@/views/Activity/Collage.vue')
    },
    {
        path: '/:mchId/Activity/SetMeal',
        name: 'Collage',
        meta: {
            title: '保养套餐',
            isFlag: false,
        },
        component: () => import('@/views/Activity/SetMeal.vue')
    },
    {
        path: '/:mchId/Activity/FreeOrder',
        name: 'FreeOrder',
        meta: {
            title: '买套餐免单',
            isFlag: false,
        },
        component: () => import('@/views/Activity/FreeOrder.vue')
    },
    {
        path: '/:mchId(\\d+)/OrderList',
        name: 'OrderList',
        meta: {
            title: '我的订单',
            isFlag: false,
        },
        component: () => import('@/views/Order/List.vue'),
    },
    // {
    //     path: '/:mchId(\\d+)/MyCoupon',
    //     name: 'CouponsList',
    //     meta: {
    //         title: '特惠续购',
    //         isFlag: false
    //     },
    //     component: () => import('@/views/My/Coupons/Index.vue'),
    // },
    {
        path: '/:mchId(\\d+)/Activity/Renewal',
        name: 'ActivityRenewPurchase',
        meta: {
            title: '特惠续购',
            isFlag: false
        },
        component: () => import('@/views/Activity/Renewal.vue'),
    },
    {
        path: '/:mchId(\\d+)/ScanQrCoupons',
        name: 'ScanQrCoupons',
        meta: {
            title: '领券卡券',
            isFlag: false
        },
        component: () => import('@/views/My/Coupons/ScanQrCoupons.vue'),
    },

    {
        path: '/:mchId(\\d+)/OrderDetails',
        name: 'OrderDetails',
        meta: {
            title: '订单详情',
            isFlag: false,
        },
        component: () => import('@/views/Order/Details.vue'),
    },
    {
        path: '/:mchId(\\d+)/CarList',
        name: 'CarList',
        meta: {
            title: '车辆管理',
            isFlag: false,
        },
        component: () => import('@/views/My/Car/List.vue'),
    },
    {
        path: '/:mchId(\\d+)/CarArchive',
        name: 'CarArchive',
        meta: {
            title: '车辆档案',
            isFlag: false,
        },
        component: () => import('@/views/My/Car/CarArchive.vue'),
    },
    {
        path: '/:mchId(\\d+)/My/CompleteInfo',
        name: 'CompleteInfo',
        meta: {
            title: '完善信息',
            isFlag: false,
        },
        component: () => import('@/views/My/CompleteInfo.vue'),
    },

    // 报价单路由，不要随意修改
    {
        path: '/:mchId(\\d+)/Quotation',
        name: 'Quotation',
        meta: {
            title: '报价单',
            isFlag: false,
        },
        component: () => import('@/views/PushService/Quotation/Index.vue'),
        children: [
            {
                path: "Detail",
                name: "QuotationDetail",
                component: () => import('@/views/PushService/Quotation/Detail.vue'),
                meta: {
                    title: '报价单详情',
                    isFlag: false,
                },
            },

        ],
    },
    {
        path: "/:mchId(\\d+)/QuotationList",
        name: "QuotationList",
        component: () => import('@/views/PushService/Quotation/List.vue'),
        meta: {
            title: '报价单列表',
            isFlag: false,
        },
    },
    // 结算单
    {
        path: '/:mchId(\\d+)/Bill',
        name: 'Bill',
        meta: {
            title: "结算单",
            isFlag: false,
        },
        component: () => import("@/views/PushService/Bill/Index.vue"),
        children: [
            {
                path: "Detail",
                name: "BillDetail",
                component: () => import('@/views/PushService/Bill/Detail.vue'),
                meta: {
                    title: '结算单详情',
                    isFlag: false,
                },
            },
        ]
    },

    {
        path: '/:mchId(\\d+)/PaySuccess',
        name: 'PaySuccess',
        meta: {
            title: '付款成功',
            isFlag: false,
        },
        component: () => import('@/views/PushService/Bill/PaySuccess.vue'),
    },

    {
        path: '/:mchId(\\d+)/CommentList',
        name: 'CommentList',
        meta: {
            title: '评价列表',
            isFlag: false,
        },
        component: () => import('@/views/My/Comment/List.vue'),
    },
    {
        path: '/:mchId(\\d+)/PublishComment',
        name: 'PublishComment',
        meta: {
            title: '发表评论',
            isFlag: false,
        },
        component: () => import('@/views/My/Comment/PublishComment.vue'),
    },
    {
        path: '/:mchId(\\d+)/CommentDetail',
        name: 'CommentDetail',
        meta: {
            title: '评价详情',
            isFlag: false,
        },
        component: () => import('@/views/My/Comment/CommentDetail.vue'),
    },

    {
        path: '/:mchId(\\d+)/Group',
        name: 'Group',
        meta: {
            title: '团购',
            isFlag: false
        },
        component: () => import('@/views/Group/Index.vue'),
    },

    {
        path: '/:mchId(\\d+)/PreferentialAddPurchase',
        name: 'PreferentialAddPurchase',
        meta: {
            title: '特惠加购',
            isFlag: false
        },
        component: () => import('@/components/marketingActivity/ActivityAddPurchaseDrawer.vue'),
    },

    {
        path: '/:mchId(\\d+)/BindWeChat',
        name: 'BindWeChat',
        meta: {
            title: '账号安全验证',
            isFlag: false
        },
        component: () => import('@/views/Member/BindWeChat.vue')
    },

    {
        path: '/:mchId(\\d+)/CarWash',
        name: 'CarWash',
        meta: {
            title: '洗车账户',
            isFlag: false
        },
        component: () => import('@/views/CarWash/Index.vue'),
        redirect: '/:mchId(\\d+)/CarWash/My',
        children: [
            {
                path: 'Outlet',
                name: 'CarWash-Outlet',
                meta: {
                    title: '洗车网点',
                    isFlag: false
                },
                component: () => import('@/views/CarWash/Outlet.vue')
            },
            {
                path: 'My',
                name: 'CarWash-My',
                meta: {
                    title: '洗车账户',
                    isFlag: false
                },
                component: () => import('@/views/CarWash/My.vue')
            },
            {
                path: 'Records',
                name: 'CarWash-Records',
                meta: {
                    title: '洗车记录',
                    isFlag: false
                },
                component: () => import('@/views/CarWash/Records.vue')
            },
            {
                path: 'RecordsV2',
                name: 'CarWash-RecordsV2',
                meta: {
                    title: '洗车记录',
                    isFlag: false
                },
                component: () => import('@/views/CarWash/RecordsV2.vue')
            },
            {
                path: 'WxCustSvc',
                name: 'WxCustSvc',
                meta: {
                    title: '微信客服',
                    isFlag: false
                },
                component: () => import('@/views/CarWash/WxCustSvc.vue')
            },
            {
                path: 'Mall',
                name: 'CarWash-Mall',
                meta: {
                    title: '货柜商城',
                    isFlag: false
                },
                component: () => import('@/views/CarWash/Mall.vue')
            },
            {
                path: 'TakeOutRecords',
                name: 'CarWash-TakeOutRecords',
                meta: {
                    title: '取件记录',
                    isFlag: false
                },
                component: () => import('@/views/CarWash/TakeOutRecords.vue')
            },
            {
                path: 'DouyinCommentInvitationDesc',
                name: 'CarWash-DouyinCommentInvitationDesc',
                meta: {
                    title: '抖音评论有奖',
                    isFlag: false
                },
                component: () => import('@/views/CarWash/DouyinCommentInvitationDesc.vue')
            },
            {
                path: 'MeituanCommentInvitationDesc',
                name: 'CarWash-DouyinCommentInvitationDesc',
                meta: {
                    title: '美团评论有奖',
                    isFlag: false
                },
                component: () => import('@/views/CarWash/MeituanCommentInvitationDesc.vue')
            },
            {
                path: 'ParkingCoupon',
                name: 'CarWash-ParkingCoupon',
                meta: {
                    title: '领取停车券',
                    isFlag: false
                },
                component: () => import('@/views/CarWash/ParkingCoupon.vue')
            },
        ]
    },

    // {
    //     path: '/:mchId(\\d+)/CarWash/Outlet',
    //     name: 'CarWash-Outlet',
    //     meta: {
    //         title: '洗车网点',
    //         isFlag: false
    //     },
    //     component: () => import('@/views/CarWash/Outlet.vue')
    // },
    //
    // {
    //     path: '/:mchId(\\d+)/CarWash/My',
    //     name: 'CarWash-My',
    //     meta: {
    //         title: '洗车账户',
    //         isFlag: false
    //     },
    //     component: () => import('@/views/CarWash/My.vue')
    // },
    //
    // {
    //     path: '/:mchId(\\d+)/CarWash/Records',
    //     name: 'CarWash-Records',
    //     meta: {
    //         title: '洗车记录',
    //         isFlag: false
    //     },
    //     component: () => import('@/views/CarWash/Records.vue')
    // },

    {
        path: '/:mchId(\\d+)/CarWash/WxCustSvc',
        name: 'WxCustSvc',
        meta: {
            title: '微信客服',
            isFlag: false
        },
        component: () => import('@/views/CarWash/WxCustSvc.vue')
    },

    {
        path: '/:mchId(\\d+)/NotFound',
        name: 'NotFound',
        meta: {
            title: '404',
            isFlag: false,  // 是否显示底部导航栏
        },
        component: () => import('@/views/NotFound/Index.vue')
    },
    {
        path: "/:mchId(\\d+)/*",
        redirect: "/:mchId(\\d+)/NotFound"
    }

]

export default routes;